import { useEffect, useState } from 'react'
import { useAppSelector, useAppDispatch } from '@/hooks'
import {
  setClass1,
  setClass2,
  setMediaType,
  setStyleType,
  setClass3,
  setMaterialType
} from '@/features/SetPaintingIntroInfo/setPaintingIntroInfo'

import { Select } from 'antd'
import './index.less'
interface TagTreeI {
  value: string
  label: string
}

//画作简介
export function PaintingIntroPage() {
  const dispatch = useAppDispatch()
  const allGlobalTagTrees = useAppSelector((state) => state.sixLawsInfo.globalTagTree)
  //各种标签tags
  const class1 = useAppSelector((state) => state.paintingIntroInfo.class1) //主题
  const class2 = useAppSelector((state) => state.paintingIntroInfo.class2) //类型
  const mediaType = useAppSelector((state) => state.paintingIntroInfo.mediaType) //材质
  const styleType = useAppSelector((state) => state.paintingIntroInfo.styleType) //形制
  const class3 = useAppSelector((state) => state.paintingIntroInfo.class3) //题材
  const materialType = useAppSelector((state) => state.paintingIntroInfo.materialType) //设色
  const description = useAppSelector((state) => state.paintingIntroInfo.description) //简介

  const [class1TagTree, setClass1TagTree] = useState<TagTreeI[]>([])
  const [class2TagTree, setClass2TagTree] = useState<TagTreeI[]>([])
  const [mediaTypeTagTree, setMediaTypeTagTree] = useState<TagTreeI[]>([])
  const [styleTypeTagTree, setStyleTypeTagTree] = useState<TagTreeI[]>([])
  const [class3TagTree, setClass3TagTree] = useState<TagTreeI[]>([])
  const [materialTypeTagTree, setMaterialTypeTagTree] = useState<TagTreeI[]>([])

  //更新每一项的TagTree
  useEffect(() => {
    //主题
    const newClass1TagTree: TagTreeI[] = []
    for (let i = 0; i < allGlobalTagTrees.主题.length; i++) {
      newClass1TagTree.push({
        value: allGlobalTagTrees.主题[i],
        label: allGlobalTagTrees.主题[i]
      })
    }
    setClass1TagTree(newClass1TagTree)

    //类型
    const newClass2TagTree: TagTreeI[] = []
    for (let i = 0; i < allGlobalTagTrees.类型.length; i++) {
      newClass2TagTree.push({
        value: allGlobalTagTrees.类型[i],
        label: allGlobalTagTrees.类型[i]
      })
    }
    setClass2TagTree(newClass2TagTree)

    //材质
    const newMediaTypeTagTree: TagTreeI[] = []
    for (let i = 0; i < allGlobalTagTrees.材质.length; i++) {
      newMediaTypeTagTree.push({
        value: allGlobalTagTrees.材质[i],
        label: allGlobalTagTrees.材质[i]
      })
    }
    setMediaTypeTagTree(newMediaTypeTagTree)

    //形制
    const newStyleTypeTagTree: TagTreeI[] = []
    for (let i = 0; i < allGlobalTagTrees.形制.length; i++) {
      newStyleTypeTagTree.push({
        value: allGlobalTagTrees.形制[i],
        label: allGlobalTagTrees.形制[i]
      })
    }
    setStyleTypeTagTree(newStyleTypeTagTree)

    //题材
    const newClass3TagTree: TagTreeI[] = []
    for (let i = 0; i < allGlobalTagTrees.题材.length; i++) {
      newClass3TagTree.push({
        value: allGlobalTagTrees.题材[i],
        label: allGlobalTagTrees.题材[i]
      })
    }
    setClass3TagTree(newClass3TagTree)

    //设色
    const newMaterialTypeTagTree: TagTreeI[] = []
    for (let i = 0; i < allGlobalTagTrees.设色.length; i++) {
      newMaterialTypeTagTree.push({
        value: allGlobalTagTrees.设色[i],
        label: allGlobalTagTrees.设色[i]
      })
    }
    setMaterialTypeTagTree(newMaterialTypeTagTree)
  }, [allGlobalTagTrees])

  return (
    <div className='paintingIntro-panel'>
      <div className='paintingIntro-tags-panel'>
        <div className='select-item'>
          <div className='select-text'>主 题</div>
          <Select
            value={class1}
            options={class1TagTree}
            onChange={(value) => {
              dispatch(setClass1(value))
            }}
          />
        </div>
        <div className='select-item'>
          <div className='select-text'>类 型</div>
          <Select
            value={class2}
            options={class2TagTree}
            onChange={(value) => {
              dispatch(setClass2(value))
            }}
          />
        </div>
        <div className='select-item'>
          <div className='select-text'>材 质</div>
          <Select
            value={mediaType}
            options={mediaTypeTagTree}
            onChange={(value) => {
              dispatch(setMediaType(value))
            }}
          />
        </div>
        <div className='select-item'>
          <div className='select-text'>形 制</div>
          <Select
            value={styleType}
            options={styleTypeTagTree}
            onChange={(value) => {
              dispatch(setStyleType(value))
            }}
          />
        </div>
        <div className='select-item'>
          <div className='select-text'>题 材</div>
          <Select
            value={class3}
            options={class3TagTree}
            onChange={(value) => {
              dispatch(setClass3(value))
            }}
          />
        </div>
        <div className='select-item'>
          <div className='select-text'>设 色</div>
          <Select
            value={materialType}
            options={materialTypeTagTree}
            onChange={(value) => {
              dispatch(setMaterialType(value))
            }}
          />
        </div>
      </div>
      <div className='paintingIntro-info-panel'>{description}</div>
    </div>
  )
}
